// Copyright (c) StrangeBee 2023

import { SecurityTag } from '@Atoms/Info';
import { ReactElement } from 'react';
import { SeverityValues, TLPValues } from 'thehive-sdk';

import './CaseTemplateListFlags.scss';

interface CaseTemplateListFlagsProps {
    tlp: TLPValues;
    severity: SeverityValues;
    onClick: (field: 'tlp' | 'severity') => void;
}

export const CaseTemplateListFlags = ({ tlp = 0, severity = 1, onClick }: CaseTemplateListFlagsProps): ReactElement => {
    return (
        <div className="case-template-list-flags">
            <SecurityTag type="tlp" value={tlp} onClick={() => onClick('tlp')} />
            <SecurityTag type="severity" value={severity} onClick={() => onClick('severity')} />
        </div>
    );
};
